import { NgIfContext } from '@angular/common';
import { Component, OnInit, TemplateRef } from '@angular/core';

import { Router } from '@angular/router';
import { UserMeetBalanceService } from 'src/app/services/v2/users/user-meet-balance.service';

@Component({
  selector: 'app-user-meet-balance',
  templateUrl: './balance.component.html',
  styleUrls: ['./balance.component.scss']
})
export class BalanceComponent implements OnInit {
  balances: any[] = [];
  public loading: boolean = true;
  loadingTemplate: TemplateRef<NgIfContext<boolean>>;

  constructor(
    private userMeetBalanceService: UserMeetBalanceService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.loading = true;
    this.userMeetBalanceService.getUserBalances().subscribe({
      next: (response) => { this.balances = response; },
      complete: () => { this.loading = false },
      error: () => { this.loading = false }
    });
  }

  getMeetTypeName(meetType: string): string {
    const map: Record<string, string> = {
      initial_call: 'Llamada Inicial',
      therapists_front: 'Frente de Terapeutas',
      landing_ssri: 'Landing SSRI',
      public_call: 'Llamada Pública',
      get_10_minutes_free: '10 Minutos Gratis',
      master_coach_15_min: 'Master Coach 15 Min',
      master_coach_30_min: 'Master Coach 30 Min',
      follow_up: 'Seguimiento',
      initial_call_mx: 'Llamada Inicial MX'
    };
    return map[meetType] || meetType;
  }
}
